import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Container } from "./style";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import staticNews from "./staticNews";
import StatisticsNavigation from "./StatisticComponents";
import "./main.css";

const AppStyled = styled.div``;

const Content = styled.div`
  padding: 20px 0;
  background-color: #f5f5f4;
`;

const NewsSection = styled.section`
  margin-bottom: 20px;
`;

const ViewAllLink = styled(Link)`
  display: inline-block;
  margin-top: 15px;
  color: #007bff;
  text-decoration: none;
  font-weight: bold;
  &:hover {
    text-decoration: underline;
  }
`;

function Main() {
  const { t, i18n } = useTranslation();
  const [dynamicNews, setDynamicNews] = useState([]);

  useEffect(() => {
    console.log("Fetching news for Main, language:", i18n.language);
    fetch(`https://abt.tj/news-backend/api/news?limit=10&t=${Date.now()}`, {
      headers: { "X-API-Key": "2025" },
    })
      .then((res) => {
        if (!res.ok) throw new Error(`Failed to fetch news: ${res.status}`);
        return res.json();
      })
      .then((data) => {
        console.log("API Response (Main):", data);
        const formattedNews = data.news.map((item) => {
          const [day, month, year] = item.date.split(".");
          const dateObj = new Date(
            parseInt(year),
            parseInt(month) - 1,
            parseInt(day),
          );

          return {
            id: `api-${item.id}`,
            date: `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`,
            dateObj: dateObj, // Добавляем объект Date для точной сортировки
            timestamp: dateObj.getTime(), // Добавляем timestamp для более надежной сортировки
            title: item.title[i18n.language] || item.title["ru"] || "No title",
            path: `/news/${item.id}`,
          };
        });
        console.log("Formatted Dynamic News:", formattedNews);
        setDynamicNews(formattedNews);
      })
      .catch((err) => {
        console.error("API Error (Main):", err.message);
        setDynamicNews([]);
      });
  }, [i18n.language]);

  // Нормализация статических новостей
  const formattedStaticNews = staticNews.map((item) => {
    let normalizedDate = item.date;
    let dateObj;

    // Если дата в формате DD-MM-YYYY или DD.MM.YYYY, преобразуем в YYYY-MM-DD
    if (item.date.includes("-") || item.date.includes(".")) {
      const [day, month, year] = item.date.split(/[-.]/);
      normalizedDate = `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
      dateObj = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
    } else {
      // Если уже в формате YYYY-MM-DD
      const [year, month, day] = normalizedDate.split("-");
      dateObj = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
    }

    return {
      ...item,
      id: `static-${item.id}`,
      date: normalizedDate,
      dateObj: dateObj,
      timestamp: dateObj.getTime(),
      title: item.titleKey ? t(item.titleKey) : item.title || "No title",
    };
  });
  console.log("Formatted Static News:", formattedStaticNews);

  // Объединение и сортировка по timestamp (от новых к старым)
  const allNews = [...formattedStaticNews, ...dynamicNews]
    .sort((a, b) => {
      console.log(
        `Sorting: ${a.id} (${a.date}, timestamp: ${a.timestamp}) vs ${b.id} (${b.date}, timestamp: ${b.timestamp})`,
      );
      return b.timestamp - a.timestamp; // Сортировка по убыванию (новые первые)
    })
    .slice(0, 5);

  console.log(
    "All News (Main) - Final:",
    allNews.map((n) => ({
      id: n.id,
      date: n.date,
      timestamp: n.timestamp,
      title: n.title,
    })),
  );

  return (
    <AppStyled>
      <Content>
        <Container>
          <div className="page">
            <div className="column">
              {/* Exchange Rates Section */}
              <section className="section">
                <h2 className="section__title">
                  {t("dashboard.exchangeRates.title")}
                </h2>
                <div className="rates-grid">
                  {Object.entries({
                    usdTjs: "9.4447",
                    eurTjs: "11.0919",
                    rubTjs: "0.1257",
                    cnyTjs: "1.3835",
                  }).map(([key, value]) => (
                    <div className="rates-item" key={key}>
                      <div className="rates-item__label">
                        {t(`dashboard.exchangeRates.pairs.${key}`)}
                      </div>
                      <div className="rates-item__value">{value}</div>
                    </div>
                  ))}
                </div>
              </section>

              {/* Gold Rate Section */}
              <section className="section">
                <h2 className="section__title">
                  {t("dashboard.goldRate.title")}
                </h2>
                <div className="rates-grid">
                  <div className="rates-item">
                    <div className="rates-item__label">
                      {t("dashboard.goldRate.buy")}
                    </div>
                    <div className="rates-item__value">146324.38 / 100 гр</div>
                  </div>
                  <div className="rates-item">
                    <div className="rates-item__label">
                      {t("dashboard.goldRate.sell")}
                    </div>
                    <div className="rates-item__value">143426.87 / 100 гр</div>
                  </div>
                </div>
              </section>

              {/* Economic Indicators Section */}
              <section className="section">
                <h2 className="section__title">
                  {t("dashboard.economicIndicators.title")}
                </h2>
                {[
                  { key: "gdp", value: " 0,4%" },
                  { key: "inflation", value: "3,6%" },
                  { key: "unemployment", value: "56,8" },
                ].map(({ key, value }) => (
                  <div className="rates-item" key={key}>
                    <div className="rates-item__label">
                      {t(`dashboard.economicIndicators.${key}`)}
                    </div>
                    <div className="rates-item__value">{value}</div>
                  </div>
                ))}
              </section>
            </div>

            <div className="column">
              {/* Key Events Section */}
              <NewsSection className="section">
                <h2 className="section__title">
                  {t("dashboard.keyEvents.title")}
                </h2>
                {allNews.length === 0 ? (
                  <p>No news available</p>
                ) : (
                  allNews.map(({ id, date, title, path }) => (
                    <Link to={path} key={id}>
                      <div className="news-item">
                        <div className="news-item__date">{date}</div>
                        <div className="news-item__text">{title}</div>
                      </div>
                    </Link>
                  ))
                )}
                <ViewAllLink to="/all-news">Все новости</ViewAllLink>
              </NewsSection>
            </div>

            <div className="column">
              {/* President Section */}
            <section className="section">
    <img
      src="https://nbt.tj/upload/prezident.jpg"
      alt={t("dashboard.president.name")}
      className="president__image"
      loading="lazy"
    />
    <h3 className="president__name">
      {t("dashboard.president.name")}
    </h3>
    <div className="president__content">
      <p>{t("dashboard.president.quote")}</p>
    </div>
 
    {/* Кнопка на страницу Низомнома */}
    <a
     href="/awards-regulation"
  style={{
    display: "block",
    marginTop: "20px",
    borderRadius: "10px",
    border: "1px solid #e2e8f0",
    overflow: "hidden",
    textDecoration: "none",
    transition: "border-color 0.2s, box-shadow 0.2s",
  }}
  onMouseEnter={e => {
    e.currentTarget.style.borderColor = "#cbd5e0";
    e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.08)";
  }}
  onMouseLeave={e => {
    e.currentTarget.style.borderColor = "#e2e8f0";
    e.currentTarget.style.boxShadow = "none";
  }}
>
  {/* Верхняя синяя часть */}
 <div style={{ background: "#1a365d", padding: "20px 22px 18px" }}>
  <p style={{ fontSize: "14px", fontWeight: "600", color: "rgba(255,255,255,0.5)", letterSpacing: "1.2px", textTransform: "uppercase", margin: "0 0 8px" }}>
    {t("awardsCard.badge")}
  </p>
  <p style={{ fontSize: "20px", fontWeight: "600", color: "#fff", margin: 0, lineHeight: 1.45 }}>
    {t("awardsCard.title")}
  </p>
</div>
 
</a>
  </section>
            </div>
          </div>
        </Container>
      </Content>
      <StatisticsNavigation />
      <br />
    </AppStyled>
  );
}

export default Main;
